'use client';

import { SelectInput } from '@pioz/mlm-skeleton/form-fields';
import { useRouter } from 'next/navigation';
import { useGlobalSettings } from './global-settings';
import { CommonLocals } from '@pioz/mlm-common';

export function MediaLanguageSelector({
  locale,
  value = locale,
  t,
}: {
  locale: CommonLocals;
  value?: string;
  t?: {
    selectLanguage?: string;
  };
}) {
  const { push } = useRouter();
  const { known_languages } = useGlobalSettings();

  return (
    <div className="flex items-center gap-2">
      {!!t?.selectLanguage && <p>{t.selectLanguage}</p>}
      <SelectInput
        defaultValue={value}
        onChange={(e) => {
          const newValue = e.currentTarget.value;
          if (locale === newValue) {
            push('./');
          } else {
            push('./?language=' + newValue);
          }
        }}
      >
        {known_languages.map((item) => (
          <option key={item.lng_shortcut} value={item.lng_shortcut}>
            {item?.flag} {item.lng_name}
          </option>
        ))}
      </SelectInput>
    </div>
  );
}
